import { clsx } from 'clsx';
import { ButtonWithIcon } from 'src/components/Buttons';
import { Content } from 'src/contexts/ContentContext';
import { useOnSaleEventsContext } from 'src/contexts/OnSaleEventsContext/OnSaleEventsContext';
import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { ContentPlaceholder } from 'src/core/POS/ContentPlaceholder';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { useUserHasAnyOfPermissions } from 'src/hooks/useUserHasAnyOfPermissions';
import { UnlockedNewIcon } from 'src/svgs';
import { IconsFill } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import { Permission } from 'src/WebApiController';

import * as styles from './OnSaleEventMetrics.css';

export const OnSaleEventMetricsLocked = ({
  onOpenDialog,
}: {
  onOpenDialog: () => void;
}) => {
  const { isDarkMode } = useSiteTheme();
  const { isLoadingAccess } = useOnSaleEventsContext();
  const hasManageEventDiscoveryPermission = useUserHasAnyOfPermissions(
    Permission.Events_ManageEventDiscovery
  );

  return (
    <Stack
      width="full"
      justifyContent="spaceBetween"
      gap="xl"
      className={clsx(styles.OnSaleEventMetricsContainer, {
        [styles.OnSaleEventMetricsContainerDark]: isDarkMode,
      })}
    >
      {isLoadingAccess ? (
        <Stack direction="column" width="full" gap="s">
          <ContentPlaceholder width="100%" height="2rem" />
          <ContentPlaceholder width="100%" height="2rem" />
          <ContentPlaceholder width="100%" height="2rem" />
        </Stack>
      ) : (
        <>
          <Stack
            direction="column"
            height="full"
            gap="l"
            alignItems="center"
            className={clsx(styles.OnSaleEventMetricsLockedDescription, {
              [styles.OnSaleEventMetricsLockedDescriptionDark]: isDarkMode,
            })}
          >
            <div className={styles.OnSaleEventMetricsLockedDescriptionTitle}>
              <Content id={ContentId.GetVisitsAndTransactionsInsights} />
            </div>
            <div className={styles.OnSaleEventMetricsLockedDescriptionSubtitle}>
              {hasManageEventDiscoveryPermission ? (
                <Content
                  id={ContentId.UnLockOnSaleEventVisitsAndTransactionsData}
                />
              ) : (
                <Content id={ContentId.ContactOwnerToUnlock} />
              )}
            </div>
          </Stack>
          <div className={styles.OnSaleEventMetricsLockedAction}>
            <ButtonWithIcon
              disabled={!hasManageEventDiscoveryPermission}
              icon={
                <UnlockedNewIcon
                  stroke={IconsFill.currentColor}
                  size={vars.iconSize.l}
                />
              }
              className={clsx({
                [styles.actionableDark]: isDarkMode,
              })}
              textContentId={ContentId.Unlock}
              onClick={onOpenDialog}
            />
          </div>
        </>
      )}
    </Stack>
  );
};
